import { Autocomplete, TextField } from "@mui/material";

interface ChoiceEditProps {
  value: string;
  onChange: (_val: string) => void;
  options: any[];
  [key: string]: any;
}

const ChoiceEdit = ({ value, onChange, options, ...rest }: ChoiceEditProps) => (
  <Autocomplete
    getOptionLabel={(option) => (Array.isArray(option) ? option[1] : option)}
    isOptionEqualToValue={(option, val) => {
      const optionValue = Array.isArray(option) ? option[0] : option;
      return optionValue === val;
    }}
    onChange={(_, newValue) => {
      if (newValue) {
        const outValue = Array.isArray(newValue) ? newValue[0] : newValue;
        onChange(outValue);
      }
    }}
    options={options}
    renderInput={(params) => <TextField {...params} size="small" variant="standard" />}
    value={Array.isArray(value) ? value : options.find((opt) => (Array.isArray(opt) ? opt[0] : opt) === value) || null}
    disableClearable
    {...rest}
  />
);

export default ChoiceEdit;
